import type { Metadata } from "next";

import { buildImgixUrl } from "@/lib/imgix/imgix";
import { stripAllHtml } from "@/lib/text-sanitizer/text-sanitizer";

type BuildPageMetadataParams = {
  title: string;
  siteName: string;
  description?: string | null;
  canonicalUrl: string;
  imageUrl?: string | null;
  faviconUrl?: string | null;
  locale?: string;
  noIndex?: boolean;
};

export const buildPageMetadata = ({
  title,
  siteName,
  description,
  canonicalUrl,
  imageUrl,
  faviconUrl,
  locale,
  noIndex = false
}: BuildPageMetadataParams): Metadata => {
  const fullTitle = `${title} | ${siteName}`;
  const plainDescription = description
    ? stripAllHtml(description).replace(/\s+/g, " ").trim()
    : undefined;
  const socialImage = imageUrl
    ? buildImgixUrl(imageUrl, 630, 1200, "crop")
    : undefined;
  const images = socialImage
    ? [{ url: socialImage, width: 1200, height: 630, alt: title }]
    : undefined;

  return {
    title: fullTitle,
    description: plainDescription,
    icons: faviconUrl ? { icon: buildImgixUrl(faviconUrl) } : undefined,
    alternates: { canonical: canonicalUrl },
    robots: {
      index: !noIndex,
      follow: !noIndex
    },
    openGraph: {
      type: "website",
      title,
      description: plainDescription,
      siteName,
      locale,
      url: canonicalUrl,
      images
    },
    twitter: {
      card: socialImage ? "summary_large_image" : "summary",
      title,
      description: plainDescription,
      images: socialImage ? [socialImage] : undefined
    }
  };
};
